const vulval = [

        
        {label:"Problem",
        controlType:"checkbox group",
        options:["Mass", "Ulcer ", "Bleeding"]
        },
        
        {label:"Size (cm)",
        controlType:"number",
        options:[]
        },
    
        {label:"Area involved",
        controlType:"checkbox group",
        options:["Perineum", "Labia majora", "Labia minora", "Vaginal introitus", "Vagina"]
        },
    
        { label:"Consistency:",
        controlType:"radio button",
        options:["Hard", "Soft"]
        },
    
        {label:"Texture:",
        controlType:"radio button",
        options:["Smooth", "Irregular"]
        },
    
        {label:"Pain:",
        controlType:"radio button",
        options:["Painful", "Painless"]
        },
    
        { 
        label:"Present for several:",
        controlType:"radio button",
        options:["Days", "Weeks","Months","Years"]
        }
    
    ]

    export default vulval
    














